// utils/formatContenido.js
// Round 2 UI fixes (2026-06-07) — Item 1.
//
// El campo CONTENIDO viene de SQL como decimal(20,6) por lo que MariaDB lo
// devuelve siempre con 6 decimales ("12.000000", "216.500000"). Mostrar eso
// al usuario es ruido visual.
//
// Reglas:
//  - Si el valor es null/undefined/'' -> '—'
//  - Si el valor es entero (12.000 -> 12) -> sin decimales
//  - Si tiene decimales no triviales -> 2 decimales máximo (recortar ceros)
//
// Usa Number.isInteger sobre el valor parseado para detectar enteros reales.
// No usa Intl: el contenido es número técnico (250, 1.5), no moneda — separadores
// de miles entorpecen lectura. Sí tabular-nums vía CSS en los nodos que lo muestran.

export function formatContenido(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  if (!Number.isFinite(n)) return String(value);
  if (Number.isInteger(n)) return String(n);
  // Recortar a 2 decimales y eliminar ceros finales innecesarios (216.50 -> 216.5).
  const fixed = n.toFixed(2);
  return fixed.replace(/\.?0+$/, '');
}

export default formatContenido;
